import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, Link } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { TextInput } from 'src/components/text-input'
import { useCopy } from 'src/hooks'
import { getPolygonscanAddressUrl, shortenStringMiddle } from 'src/common/utils'

import { useStyles } from './styles'
import { LinkIcon } from 'src/assets/icons'
import { ETranslationNs } from 'src/types'

interface Props {
  address?: string
  fullWidth?: boolean
  shorten?: boolean
  withLink?: boolean
}

export const WalletAddressInput = ({ address, fullWidth, shorten, withLink }: Props) => {
  const [t] = useTranslation(ETranslationNs.Form)
  const classes = useStyles()
  const handleCopy = useCopy(address)
  return (
    <TextInput
      fullWidth={fullWidth}
      inputPlaceholder=""
      disabled
      inputUpperLabel={t('wallet-address-input-label.v')}
      value={address ? (shorten ? shortenStringMiddle(address) : address) : undefined}
      fontSize={13}
      endIcon={
        <div className={classes.iconsWrapper}>
          {withLink && (
            <IconButton
              disabled={!address}
              size="small"
              component={Link}
              href={address ? getPolygonscanAddressUrl(address) : '#'}
              target="_blank"
            >
              <LinkIcon className={classes.copyIcon} />
            </IconButton>
          )}
          <IconButton size="small" disabled={!address} onClick={handleCopy}>
            <ContentCopyIcon className={classes.copyIcon} />
          </IconButton>
        </div>
      }
    />
  )
}
